export default __webpack_public_path__ + "static/media/record.23398416.svg";